export const shouldShowInsuranceDescriptionAsCenterDescription = (
  currentRefinements
) => {
  return currentRefinements?.price?.includes('Insurance Accepted') || false
}
